/**
 * Training Video Constants
 *
 * Centralized UI messages for the training feature.
 * All video metadata (title, description, duration, category) comes from the backend API.
 * Video URLs are generated server-side via Managed Identity SAS tokens.
 */

// ---------------------------------------------------------------------------
// UI messages
// ---------------------------------------------------------------------------
/** Centralized training UI messages (use via useTranslate) */
export const TRAINING_MESSAGES = {
    PAGE_TITLE: 'Training Center',
    PAGE_SUBTITLE: 'Master Data Doctor with step-by-step video guides',
    SEARCH_PLACEHOLDER: 'Search videos...',
    WATCH_NOW: 'Watch Now',
    NO_VIDEOS: 'No videos found matching your search.',
    WELCOME_TITLE: 'Welcome to Data Doctor!',
    WELCOME_SUBTITLE: 'Get started with a quick tour',
    WELCOME_CTA: 'Watch Now',
    WELCOME_DISMISS: 'Skip for Now',
    WATCH_TUTORIAL: 'Watch Tutorial',
    LOADING_VIDEOS: 'Loading training videos...',
    FAILED_TO_LOAD: 'Failed to load training videos',
    SELECT_VIDEO: 'Select a video to start learning',
    NOW_PLAYING: 'Now Playing',
    VIDEO_DETAILS: 'Video Details',
    ALL_CATEGORIES: 'All',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
} as const;


